/**
 * Created by Udara Prabath
 * Date: 10/20/2020
 * Using: IntelliJ IDEA
 */
import React from 'react';
import './Landing.scss'
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router";

// core components
import Header from "../../../components/Header/Header";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import * as actionInstituteCreator from "../../../store/domain/institute/action";
import * as instituteService from "../../../services/institute";
import * as commonFunc from "../../../utils/commonFunc";
import {getSliderSetting} from "../../../utils/commonFunc";
import TeachersSlides from "../../../components/TeachersSlides/TeachersSlides";
import NotFound from "../../../components/NotFound/NotFound";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import {Carousel} from 'react-responsive-carousel';
import SpecialNotification from "../special-Notification/SpecialNotification";
import ViewCourses from '../../../components/viewCourses/viewCourses'
import * as courseService from "../../../services/courses";
import banner from '../../../assets/img/institute/sakya-default.jpg'
import webConfig from '../../../config/WebConfig'
import LandingLayout01 from "./version-01/Landing-Layout01";
import LandingLayout02 from "./version-02/Landing-Layout02";
import LandingLayout04 from "./version-04/Landing-Layout04";
import LandingLayout05 from "./version-05/Landing-Layout05";
import * as constants from "../../../const/constants";
import TeacherVersionOne from "../teacher/Teacher-version-01/Teacher";

class Landing extends React.Component {

    state = {
        courses: [],
        viewCourse: false
    };

    fetchInstituteTeachers = async () => {
        this.props.spinnerHandler({isSpin: true, type: 15});
        await instituteService.getInstituteTeachers()
            .then(response => {
                this.props.spinnerHandler(false);
                if (response.success) {
                    this.props.fetchTeachers(response.body.teachers);
                } else {
                    commonFunc.notifyMessage(response.message, response.status)
                }
            })
    };

    fetchInstituteCourses = async () => {

        this.props.spinnerHandler({isSpin: true, type: 15});
        await courseService.getInstituteCourses().then(
            res => {
                if (res.success) {
                    this.setState({
                        courses: res.body
                    });
                    this.setState({
                        viewCourse: true
                    });
                    this.props.spinnerHandler(false);
                } else {
                    this.setState({
                        viewCourse: false
                    });
                    this.props.spinnerHandler(false);
                }

            }
        )
    };


    async componentDidMount() {
        // document.documentElement.scrollTop = 0;
        // document.scrollingElement.scrollTop = 0;
        // this.refs.main.scrollTop = 0;
        // await this.fetchInstituteTeachers();
        // await this.fetchInstituteCourses();
    }

    render() {
        let {institute, teachers, userType, course} = this.props;
        let settings = getSliderSetting(teachers);
        return (
            <div>

                <Header active={0}/>
                <main ref="main" className={"landing"}>

                    <SpecialNotification/>

                    {
                        webConfig.layout === constants.LAYOUT_OUT_01 && webConfig.instituteType === constants.INSTITUTE ?
                            <LandingLayout01 lmsStatus={webConfig.LMSStatus} /> :
                            webConfig.layout === constants.LAYOUT_OUT_01 && webConfig.instituteType === constants.SINGLE_TEACHER ?
                                <LandingLayout04 lmsStatus={webConfig.LMSStatus} /> :
                                webConfig.layout === constants.LAYOUT_OUT_02 && webConfig.instituteType === constants.INSTITUTE ?
                                    <LandingLayout02 lmsStatus={webConfig.LMSStatus} /> :
                                    webConfig.layout === constants.LAYOUT_OUT_02 && webConfig.instituteType === constants.SINGLE_TEACHER ?
                                        <LandingLayout05 lmsStatus={webConfig.LMSStatus} /> : null
                    }

                </main>

                <CardsFooter/>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    institute: state.institute.institute,
    teachers: state.institute.teachers,
    userType: state.auth.userType,
});
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    fetchTeachers: data => dispatch(actionInstituteCreator.fetchTeachers(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Landing));
